import React, { useMemo, useContext } from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { BackToTop } from '@thd-olt-component-react/back-to-top';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import { LayoutManager } from '@thd-olt-component-react/layout-manager';
import { MediaGalleryDesktop } from '@thd-olt-component-react/media-gallery';
import { propTypes } from './KitchenCollectionPropTypes';
import {
  AvailableOptionsTabs,
  KitchenCollectionDescription,
  KitchenCollectionTitle
} from './subcomponents';
import './kitchen-collection.scss';
import { KitchenCollectionDataModel } from './KitchenCollectionDataModel';
import { KitchenCollectionSection } from './subcomponents/KitchenCollectionSection';
import { getVendorCollectionBreadCrumbs } from './BreadCrumbsGenerator';

export const KitchenCollectionDesktop = ({
  collectionName,
  onChange
}) => {
  const {
    data: kitchenCollectionData,
    error: kitchenCollectionError,
    loading: kitchenCollectionLoading
  } = useDataModel('fetchCollectionsContent', {
    variables: { collectionName },
    ssr: true
  });

  const { fetchCollectionsContent } = kitchenCollectionData || {};
  const {
    media,
    title,
    brand,
    availableOptions,
    section,
    description
  } = fetchCollectionsContent || {};

  const kitchenCollectionSections = useMemo(
    () => section?.map((sect) => <KitchenCollectionSection section={sect} channel="desktop" key={sect.title} />),
    [section]
  );
  const { path } = useContext(ExperienceContext);
  if ((kitchenCollectionLoading && !kitchenCollectionData?.fetchCollectionsContent) || kitchenCollectionError) {
    return null;
  }

  return (
    <Row className="kitchen-collection">
      <Col>
        <Breadcrumbs staticCrumbs={getVendorCollectionBreadCrumbs(path)} />
      </Col>
      <Col>
        <LayoutManager name="Kitchen Collection">
          <div className="kitchen-collection__row-a">
            {media && (
              <div className="kitchen-collection__media">
                <KitchenCollectionTitle
                  className="kitchen-collection__title--tablet"
                  name={title}
                  brandName={brand}
                />
                <MediaGalleryDesktop overrideData={{ media, brandNameLabel: brand, galleryLabel: title }} />
              </div>
            )}
            <div className="kitchen-collection__details">
              <KitchenCollectionTitle
                className="kitchen-collection__title--desktop"
                name={title}
                brandName={brand}
              />
              <AvailableOptionsTabs
                collectionName={collectionName}
                onChange={onChange}
                availableOptions={availableOptions || []}
                channel="desktop"
              />
              <KitchenCollectionDescription description={description} />
            </div>
          </div>
          {kitchenCollectionSections}
        </LayoutManager>
        <BackToTop />
      </Col>
    </Row>
  );
};

KitchenCollectionDesktop.displayName = 'KitchenCollectionDesktop';

KitchenCollectionDesktop.dataModel = KitchenCollectionDataModel;

KitchenCollectionDesktop.propTypes = propTypes;